/* @flow */

import React from 'react';

import InformationPage from './InformationPage';

const ZkaiExternalDestinationList = () => (
  <InformationPage
    hasCloseButton={true}
    title="アプリにおける外部送信一覧"
  >
    <p>
      株式会社Z会のプログラミング学習「Z-pro」をとおして、株式会社ソニー・グローバルエデュケーション（以下「SGED」といいます）が提供する、体験型プログラミング教育サービス（以下、「本サービス」といいます）では、本サービスを提供するにあたって様々なパートナーのサービスを利用しており、それらの利用で必要となる利用者に関する情報が、お客様のパソコンやスマートフォン等の端末からパートナーへ外部送信される場合があります。この様な外部送信について、電気通信事業法の外部送信規律に基づき以下の通り公表します。
    </p>
    <p>
      ※ ウェブサイトにおける外部送信一覧はこちらをご確認ください
    </p>
    <h3>1. Google Analytics</h3>
    <ul>
      <li>•　送信先企業名: Google LLC</li>
      <li>•　送信先の主な利用目的：行動履歴情報を収集し、閲覧の傾向や行動履歴を分析するため</li>
      <li>•　SGEDの主な利用目的：本サービスのアクセス解析</li>
      <li>•　リンク先：
        <ul style={{ marginInlineStart: 20 }}>
          <li>∙　<a target="_blank" rel="noopener noreferrer" className="proc-link" href="http://www.google.com/analytics/terms/jp.html">
              Google Analytics利用規約
            </a>
          </li>
          <li>∙　<a target="_blank" rel="noopener noreferrer" className="proc-link" href="http://www.google.com/intl/ja/policies/privacy/partners/">
              Googleプライバシーポリシー
            </a>
          </li>
        </ul>
      </li>
      <li>•　送信される情報：閲覧サイトのURL、閲覧サイトのタイトル、IPアドレス、当社サイト訪問前に閲覧したサイトのURL、ウェブブラウザやデバイスの種類、ブラウザバージョン、デバイスの画面サイズ、ページビュー・クリックなどのユーザーイベント、など</li>
    </ul>
    <h3>2. Sentry</h3>
    <ul>
      <li>•　送信先企業名: FUNCTIONAL SOFTWARE, INC.</li>
      <li>•　送信先の主な利用目的：システム管理、システムセキュリティなど、サイトとサービスを提供、維持、および改善のため</li>
      <li>•　SGEDの主な利用目的：本サービスの不具合情報収集</li>
      <li>•　リンク先：
        <ul style={{ marginInlineStart: 20 }}>
          <li>∙　<a target="_blank" rel="noopener noreferrer" className="proc-link" href="https://sentry.io/terms/">Sentry利用規約</a></li>
          <li>∙　<a target="_blank" rel="noopener noreferrer" className="proc-link" href="https://sentry.io/privacy/">Sentryプライバシーポリシー</a></li>
        </ul>
      </li>
      <li>•　送信される情報：閲覧サイトのURL、IPアドレス、ユーザーエージェント、ウェブブラウザやデバイスの種類、ブラウザバージョン、JavaScriptエラーログ、など</li>
    </ul>
  </InformationPage>
);

export default ZkaiExternalDestinationList;
